import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';
import { callApi } from './loadingSaga';
import Api from '../api/mentorApi';
import * as Actions from '../actions/mentorActions';
import * as LoadingActions from '../actions/loadingActions';

export function* toggleSchoolAttendenceAttended(action) {
  const { attended } = yield call(callApi, Api.toggleSchoolAttendenceAttended, action.payload.id);
  yield put(Actions.setSchoolAttendanceAttended({
    id: action.payload.school_application_id,
    attended,
  }));
}

export function* saveProgressComment(action) {
  const { progress_comment } = yield select((state) => state.form.schoolDaysProgressComment.values.school_applications[action.payload.school_application_id]);
  if (progress_comment === null) {
    return;
  }
  yield call(callApi, Api.saveProgressComment, action.payload.id, progress_comment);
  yield put(LoadingActions.setErrorMessage('保存しました'));
  yield put(LoadingActions.setAlert(true));
  yield put({ type: LoadingActions.SAGA_START_PROGRESS });
}

export default function* mypageSaga() {
  yield takeLatest(Actions.SAGA_TOGGLE_SCHOOL_ATTENDANCE_ATTENDED, toggleSchoolAttendenceAttended);
  yield takeLatest(Actions.SAGA_SAVE_PROGRESS_COMMENT, saveProgressComment);
}
